import { useEffect, useState } from 'react';

import { usageApi } from '../../services/usageApi';

/**
 * Compact "usage this month" widget for the bottom of the sidebar.
 * Shows the tenant's current-month Anthropic spend + AI call count.
 * Fails quietly (renders nothing) so it never disrupts navigation.
 */
export function UsageWidget() {
  const [usage, setUsage] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    usageApi
      .getCurrentMonthUsage()
      .then((data) => active && setUsage(data))
      .catch(() => active && setError(true));
    return () => {
      active = false;
    };
  }, []);

  if (error) return null;

  if (!usage) {
    return (
      <div className="px-3 py-2 text-xs text-gray-400 dark:text-gray-500">
        Usage this month…
      </div>
    );
  }

  const cost = (usage.cost_usd ?? 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  const calls = usage.call_count ?? 0;

  return (
    <div className="px-3 py-2 rounded-lg bg-gray-100 dark:bg-gray-800">
      <p className="text-[11px] font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">
        Usage this month
      </p>
      <p className="mt-0.5 text-sm font-semibold text-gray-900 dark:text-gray-100">
        {cost}
      </p>
      <p className="text-xs text-gray-500 dark:text-gray-400">
        {calls.toLocaleString()} AI {calls === 1 ? 'call' : 'calls'}
      </p>
    </div>
  );
}

export default UsageWidget;
